import { useEffect } from "react";
import { useAppStore } from "../store/appStore";

export const useTemplateFromURL = () => {
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const urlTemplateId = urlParams.get("templateId");
        useAppStore.setState({ selectedTemplateId: urlTemplateId });
        console.info("[useTemplateFromURL] Selected template id:", urlTemplateId);
        urlParams.delete("templateId");
        window.history.replaceState(
            {},
            document.title,
            window.location.pathname + (urlParams.toString() ? `?${urlParams.toString()}` : "")
        );
    }, []);
};
